module.exports = __webpack_public_path__ + "img/style_model_preview_674.3b8a2723.jpg";